function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { CookieConsentState, CookieConsentType, CookieName } from '../consts';
var modalHTMLTemplate = "<div id=\"external-cookies-modal-container\" style=\"opacity: 0\" class=\"ModalContainerBasedOnType_container_1sk5i4d\">\n    <div id=\"external-cookies-modal-container-inner\" class=\"DynamicContainer_container_8wmcxn\">\n        <h3 class=\"Title_title_1am66qb\">{%cookies.modal.title%}</h3>\n        <span class=\"Text_text_8qe7br\">{%cookies.modal.description%}</span>\n        <div id='cookies-modal-form'>\n            <div class=\"_140ef1h\">\n                <h3 class=\"Title_title_1o379ky\">{%cookies.modal.row.analytics_storage.title%}</h3>\n                <div id='analytics_storage_container' class=\"consentContainer__13oduao\">\n                    <span class=\"Text_text_vg966s\">{%cookies.modal.row.analytics_storage.description%}</span>\n                    <div class=\"radioContainer__bdfppm\">\n                        <label data-event-id=\"radio-budget\" class=\"RadioField_label_3r1cd0\">\n                            <input name=\"analytics_storage\" id=\"input_analytics_storage_granted\" data-state=\"granted\"\n                                class=\"RadioField_input_1bi1kgh\" type=\"radio\" value=\"\">\n                            <span class=\"RadioField_radio_jxtpmb\"></span>\n                            <span\n                                class=\"RadioField_labelMessage_1jlknzn\">{%cookies.modal.row.analytics_storage.consent.granted%}</span>\n                        </label>\n\n                        <label data-event-id=\"radio-budget\" class=\"RadioField_label_3r1cd0\">\n                            <input name=\"analytics_storage\" id=\"input_analytics_storage_denied\" data-state=\"denied\"\n                                class=\"RadioField_input_1bi1kgh\" type=\"radio\" value=\"\">\n                            <span class=\"RadioField_radio_jxtpmb\">\n\n                            </span>\n                            <span\n                                class=\"RadioField_labelMessage_1jlknzn\">{%cookies.modal.row.analytics_storage.consent.denied%}</span>\n                        </label>\n                    </div>\n                </div>\n            </div>\n            <div class=\"cookieRow__1rbbn0j\">\n                <h3 class=\"Title_title_1o379ky\">{%cookies.modal.row.personalization_storage.title%}</h3>\n                <div class=\"consentContainer__13oduao\">\n                    <span class=\"Text_text_vg966s\">{%cookies.modal.row.personalization_storage.description%}</span>\n                    <div class=\"radioContainer__bdfppm\">\n                        <label data-event-id=\"radio-budget\" class=\"RadioField_label_3r1cd0\">\n                            <input name=\"personalization_storage\" data-state=\"granted\" class=\"RadioField_input_1bi1kgh\"\n                                type=\"radio\" value=\"\">\n                            <span class=\"RadioField_radio_jxtpmb\"></span>\n                            <span class=\"RadioField_labelMessage_1jlknzn\">\n                                {%cookies.modal.row.personalization_storage.consent.granted%}\n                            </span>\n                        </label>\n                        <label data-event-id=\"radio-budget\" class=\"RadioField_label_3r1cd0\">\n                            <input name=\"personalization_storage\" data-state=\"denied\" class=\"RadioField_input_1bi1kgh\"\n                                type=\"radio\" value=\"\">\n                            <span class=\"RadioField_radio_jxtpmb\"></span><span\n                                class=\"RadioField_labelMessage_1jlknzn\">{%cookies.modal.row.personalization_storage.consent.denied%}</span></label>\n                    </div>\n                </div>\n            </div>\n            <div class=\"buttonsContainer__ghsqu8\">\n                <button \n                    class=\"cookies-modal-button link__1qy3llg\"\n                    id=\"cookies-modal-button-accept-selected\"\n                >\n                    {%cookies.modal.acceptSelected%}\n                </button>\n                <button\n                    class=\"cookies-modal-button bigLink__1eykeup\"\n                    id=\"cookies-modal-button-accept-all\"\n                >\n                    {%cookies.modal.acceptAll%}\n                </button>\n            </div>\n        </div>\n    </div>\n</div>";
import { handleAllowAll, setConsentCookies } from './shared';
import { translate } from "./translate";
import { sendConsentPageView } from './utils';

function unwrap(wrapper) {
  // place childNodes in document fragment
  var docFrag = document.createDocumentFragment();

  while (wrapper.firstChild) {
    var child = wrapper.removeChild(wrapper.firstChild);
    docFrag.appendChild(child);
  } // replace wrapper with document fragment


  wrapper.parentNode.replaceChild(docFrag, wrapper);
}

var prepareCookiesPageSpecificDOM = function prepareCookiesPageSpecificDOM(_ref) {
  var template = _ref.template,
      container = _ref.container;
  var settingsDOM = document.createRange().createContextualFragment(template);
  unwrap(settingsDOM.querySelector('#external-cookies-modal-container'));
  unwrap(settingsDOM.querySelector('#external-cookies-modal-container-inner'));
  var selectorsToRemove = ['h3', 'span'];
  selectorsToRemove.forEach(function (selector) {
    return settingsDOM.querySelector(selector).remove();
  });
  container.appendChild(settingsDOM);
};

export var prepareCookiesSettings = function prepareCookiesSettings(container) {
  var isSettings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var translated = translate(modalHTMLTemplate, 'en', {
    cookiesPageLink: function cookiesPageLink(chunks) {
      return "<a class=\"LocalizedLink_link_dy2uyj\" href=\"/cookies\">".concat(chunks, "</a>");
    }
  });

  if (isSettings) {
    prepareCookiesPageSpecificDOM({
      template: translated,
      container: container
    });
    return;
  }

  container.innerHTML = translated;
};
export var cookiesUiState;
export var setCookiesUiState = function setCookiesUiState(newState) {
  cookiesUiState = _objectSpread(_objectSpread({}, cookiesUiState), newState);
};
var checker = "<span class=\"RadioField_radioChecked_18p5z0t\"></span>";
export var hydrateButtons = function hydrateButtons(_ref2) {
  var form = _ref2.form,
      cookies = _ref2.cookies;
  var allowAllButton = form.querySelector('#cookies-modal-button-accept-all');
  var allowSelectedButton = form.querySelector('#cookies-modal-button-accept-selected');

  var handleAllowSelcted = function handleAllowSelcted() {
    setConsentCookies({
      cookies: cookies,
      consents: cookiesUiState
    });

    if (cookiesUiState[CookieConsentType.ANALYTICS_STORAGE] === CookieConsentState.GRANTED) {
      sendConsentPageView();
    }
  };

  var allowAll = function allowAll() {
    var inputs = form.querySelectorAll('input');
    handleAllowAll({
      cookies: cookies
    });
    inputs.forEach(function (input) {
      var name = input.name;
      setCookiesUiState(_defineProperty({}, name, CookieConsentState.GRANTED));
      var currentInputStateName = input.getAttribute('data-state');

      if (currentInputStateName === CookieConsentState.GRANTED) {
        var inputsContainer = input.closest('label').parentElement;
        var currentChecker = inputsContainer.querySelector('.RadioField_radioChecked_18p5z0t');

        if (currentChecker) {
          currentChecker.remove();
        }

        input.nextElementSibling.innerHTML = checker;
        input.setAttribute('checked', true);
      }
    });
  };

  allowAllButton.addEventListener('click', allowAll);
  allowSelectedButton.addEventListener('click', handleAllowSelcted);
};
export var hydrateInputs = function hydrateInputs(_ref3) {
  var form = _ref3.form,
      cookies = _ref3.cookies;
  var inputs = form.querySelectorAll('input');
  var consentCookiesState = cookies.get(CookieName.COOKIES_CONSENT);
  cookiesUiState = consentCookiesState;
  inputs.forEach(function (input) {
    var name = input.name;
    var cookieForCurrentInput = consentCookiesState[name];
    var currentInputStateName = input.getAttribute('data-state');

    if (cookieForCurrentInput === currentInputStateName) {
      input.nextElementSibling.innerHTML = checker;
      input.setAttribute('checked', true);
    }

    input.addEventListener('change', function (event) {
      var inputsContainer = event.target.closest('label').parentElement;
      var currentChecker = inputsContainer.querySelector('.RadioField_radioChecked_18p5z0t');

      if (currentChecker) {
        currentChecker.remove();
      }

      var checkerContainer = event.target.nextElementSibling;
      checkerContainer.innerHTML = checker;
      setCookiesUiState(_defineProperty({}, name, currentInputStateName));
    });
  });
};
export var injectCookiesSettings = function injectCookiesSettings(_ref4) {
  var cookies = _ref4.cookies;
  var cookiesSettingsContainer = document.getElementById('external-cookies-settings');

  if (cookiesSettingsContainer) {
    prepareCookiesSettings(cookiesSettingsContainer, true);
    var form = document.querySelector('#external-cookies-settings #cookies-modal-form');
    hydrateInputs({
      form: form,
      cookies: cookies
    });
    hydrateButtons({
      form: form,
      cookies: cookies
    });
  }
};